// Assets used across the brand kit — mapped from user-uploaded artifacts.
export const KIT_ASSETS = {
  cover: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/83ocbw6x_ChatGPT%20Image%2024%20de%20ago.%20de%202026%2C%2016_09_04.png",
  eduardo: "https://customer-assets.emergentagent.com/job_brand-portfolio-41/artifacts/btopeco7_image-gen%20%2833%29.jpg",
  mountain: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/c27bxyl6_ChatGPT%20Image%2024%20de%20ago.%20de%202026%2C%2016_17_11.png",
  adventure: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/yn9ap2ud_image-gen%20%288%29.webp",
  lifestyle: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/2lmcpt3a_image-gen%20%2852%29.png",
  travel: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/cbr9qsqe_image-gen%20%2832%29%20-%20C%C3%B3pia.webp",
  renovation: "https://customer-assets.emergentagent.com/job_brand-portfolio-41/artifacts/6xwhfb1s_Gemini_Generated_Image_wenpvdwenpvdwenp.png",
  diy: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/pxaaobnr_IMK5-Ye7NBebQ.png",
  restoration: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/nvbfracb_ChatGPT%20Image%203_08_2026%2C%2010_17_10.png",
  technologyTile: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/cwrj8smz_ChatGPT%20Image%2024%20de%20ago.%20de%202026%2C%2018_10_44.png",
  productReviews: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/cmtatwz4_ChatGPT%20Image%2024%20de%20ago.%20de%202026%2C%2018_13_06.png",
  droneCine: "https://customer-assets-4nw71qhi.emergentagent.net/job_brand-portfolio-41/artifacts/bmdlwb7o_ChatGPT%20Image%2024%20de%20ago.%20de%202026%2C%2018_16_56.png",
  technology: "https://customer-assets.emergentagent.com/job_brand-portfolio-41/artifacts/1bttsg3l_Gemini_Generated_Image_afm4wafm4wafm4wa.png",
  contact: "https://customer-assets.emergentagent.com/job_brand-portfolio-41/artifacts/csz0muos_Gemini_Generated_Image_jt2ae6jt2ae6jt2a.png",
};

export const KIT_CHANNELS = [
  {
    name: "Viver na Aldeia",
    handle: "@ViverNaAldeia",
    url: "https://www.youtube.com/@ViverNaAldeia",
    accent: "#C47A4D",
    subs: 30000,
    views: 500000,
    watch: 310000,
    impressions: 35000000,
    ctr: 11.3,
    display: {
      subs: "30K",
      views: "500K",
      watch: "310K",
      impressions: "35M",
    },
  },
  {
    name: "Trilhos em Fúria",
    handle: "@trilhosemfuria",
    url: "https://www.youtube.com/@trilhosemfuria",
    accent: "#5C8041",
    subs: 29300,
    views: 1000000,
    watch: 96000,
    impressions: 9851523,
    ctr: 5.8,
    display: {
      subs: "14.2K",
      views: "1M",
      watch: "96K",
      impressions: "9.9M",
    },
  },
];
